//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum StoreRelationType {
  /**
  * MS stores and marketplace stores are matched directly, one to one.
  *               Stocks from every MS store are sent directly to the matched marketplace store.
  *               Any number of store matchings is allowed, but a store can't be repeated
  *               and <see cref="P:mpsklad_core.Entity.Base.StoreBase.MsStoreIds" /> must have exactly one element.
  */
  Direct = 0,
  /**
  * Stocks from all MS stores are added up and sent to a single marketplace store.
  *               Only for FBS-like delivery types.
  *               Only a single marketplace store is allowed
  *               and <see cref="P:mpsklad_core.Entity.Base.StoreBase.MsStoreIds" /> is allowed to have multiple elements.
  *               <see cref="P:mpsklad_core.Entity.Base.StoreAccountBase.OrdersMsStoreId" /> must be set.
  */
  SumFromMoySklad = 1,
  /**
  * NOTE: Replaced by <see cref="F:mpsklad_core.Entity.Base.StoreRelationType.AllToOneMoySklad" />.
  *               Stocks from a single MS store are split up proportionally
  *               and sent to matched marketplace stores.
  *               Any number of store matchings is allowed, but a marketplace store can't be repeated
  *               and <see cref="P:mpsklad_core.Entity.Base.StoreBase.MsStoreIds" /> must have exactly one MS store Id, which must be the same for all stores.
  */
  SplitFromMoySklad = 2,
  /**
  * All stores from a marketplace are matched to a single MS store.
  *               Only for marketplace-managed delivery types (FBO, FBW, FBY).
  *               Any number of store matchings is allowed, but a marketplace store can't be repeated
  *               and <see cref="P:mpsklad_core.Entity.Base.StoreBase.MsStoreIds" /> must have exactly one MS store Id, which must be the same for all stores.
  */
  AllToOneMoySklad = 3,
  /**
  * Stocks from a single MS store are split per-product to a matching marketplace store based on dimensions.
  *               Only for FBS-like delivery types.
  *               A single MS store is matched to multiple marketplace stores.
  *               Each marketplace store must have a different cargo type.
  *               All stores must have exactly one MS store Id, which must be the same for all stores.
  */
  SplitMoySkladByDimensions = 4
}
